<template>
    <div class="baggage-main">
        <!-- 头 -->
        <Header ref="header" style="z-index: 9999" :title="title" :showBack="!isFromDriver"
            :isFromDriver="isFromDriver">
        </Header>

        <div class="baggage-check">
            <div class="baggage-check-card">
                <van-form @submit="onSubmit">
                    <div>

                        <van-cell title="线路名称" :value="lineClassDay.LineName" :border="false" class="baggage-cell" />
                        <van-cell title="班次日期" :value="lineClassDay.ClassDate.substring(0, 10)" :border="false"
                            class="baggage-cell" />
                        <van-cell title="班次时间" :value="lineClassDay.ClassTime.substring(0, 5)" :border="false"
                            class="baggage-cell" />
                        <van-cell title="站点名称" :value="node.NodeName" :border="false" class="baggage-cell" />

                        <van-radio-group v-model="checkVehicleGID">
                            <van-cell-group inset title="车辆选择">
                                <van-cell icon="warning-o" v-if="VehicleList.length < 1" title="暂未派车"
                                    class="baggage-cell" />
                                <van-cell v-for="item in VehicleList" :key="item.GID"
                                    :title="item.VehicleNo + '-(' + item.PassengerSeatCount + ')'" clickable
                                    @click="onVehicleClick(item)" class="baggage-cell">
                                    <template #right-icon>
                                        <van-radio :name="item.VehicleGID" />
                                    </template>
                                </van-cell>
                            </van-cell-group>
                        </van-radio-group>


                        <van-cell-group inset title="站点车辆情况">
                            <van-cell title="预计到达日期" :value="$moment(queryData.ClassTime).format('YYYY-MM-DD')"
                                @click="isShowBaggageCheckDate = true" :border="false" class="baggage-cell" is-link />

                            <van-cell title="预计到达时间" :value="$moment(queryData.ClassTime).format('HH:mm')"
                                @click="isShowBaggageCheckTime = true;" :border="false" class="baggage-cell" is-link />
                            <van-field class="baggage-cell" v-model="queryData.Remark" label="备注" placeholder="请输入备注"
                                input-align="right" type="textarea" rows="1" autosize />
                        </van-cell-group>
                    </div>

                    <div class="baggage-submit" style="margin-top: .3rem;">
                        <van-button round block type="info" native-type="submit" readonly required>
                            提交
                        </van-button>
                    </div>
                </van-form>
            </div>
        </div>

        <!-- 日期选择 -->
        <van-calendar v-model="isShowBaggageCheckDate" @confirm="confirmBaggageCheckDate"
            :default-date="new Date(queryData.ClassTime)" />

        <!-- 时间选择 -->
        <van-popup v-model="isShowBaggageCheckTime" position="bottom" @open="openBaggageCheckTimePopup">
            <van-datetime-picker v-model="baggageCheckTime" type="time" title="选择时间" @confirm="confirmBaggageCheckTime"
                @cancel="isShowBaggageCheckTime = false" />
        </van-popup>
    </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
    components: {
        Header
    },
    data() {
        return {
            title: "站点车辆状态", //标题
            isFromDriver: false,

            line: JSON.parse(window.localStorage.getItem("line")), //选择的线路
            lineClassDay: JSON.parse(window.localStorage.getItem("lineClassDay")), //选择的班次
            node: JSON.parse(window.localStorage.getItem("lineClassDayStratNode")), //选择的站点

            VehicleList: [], //已派车集合
            checkVehicleGID: null,
            isShowBaggageCheckTime: false, // 检查时间
            isShowBaggageCheckDate: false,
            nodeVehicleArrivalStatusList: [],
            baggageCheckTime: null,
            nodeVehicleArrivalTime: null,
            queryData: {
                GID: null,
                LineClassDayGID: "",
                NodeGID: "",
                VehicleGID: "",
                DifferencetTime: "",
                ClassTime: "",
                ArrivalStatus: "",
                ModifyGID: "",
                ModifyCode: "",
                ModifyName: "",
                Remark: "",
            },
        };
    },
    mounted() {
        this.getCurrentDateTime();
        this.getLocalData();
        this.onQueryLineClassDayVehicleDriver();
    },
    methods: {
        //选中车辆
        onVehicleClick(item) {
            this.checkVehicleGID = item.VehicleGID;
            this.queryData.VehicleGID = this.checkVehicleGID;
            let matchedItem = this.nodeVehicleArrivalStatusList.find(i => i.VehicleGID == item.VehicleGID);
            if (matchedItem) {
                this.queryData = JSON.parse(JSON.stringify(matchedItem)); // 深拷贝
            } else {
                this.getLocalData()
            }
        },
        //班次车辆数据获取
        onQueryLineClassDayVehicleDriver() {
            let params = {
                LineClassDayGID: this.lineClassDay.GID,
                CheckInTime: 0
            };
            this.$http
                .post(this.$api.getVehicleDriver, this.$qs.stringify(params))
                .then(res => {
                    if (res.success) {
                        this.VehicleList = res.data;
                        if (this.VehicleList.length > 0) {
                            this.checkVehicleGID = this.VehicleList[0].VehicleGID;
                            this.queryData.VehicleGID = this.checkVehicleGID;
                            this.getNodeVehicleArrivalStatus()
                        }

                    }
                });
        },
        getNodeVehicleArrivalStatus() {
            //获取车辆预计到达时间
            let nvParams = {
                LineClassDayGID: this.lineClassDay.GID,
                NodeGID: this.node.NodeGID,
            };
            this.$http
                .post(this.$api.getNodeVehicleArrivalStatus, this.$qs.stringify(nvParams))
                .then(res => {
                    if (res.success) {
                        this.nodeVehicleArrivalStatusList = res.data;
                        let matchedItem = this.nodeVehicleArrivalStatusList.find(item => item.VehicleGID === this.checkVehicleGID);
                        if (matchedItem) {
                            this.queryData = JSON.parse(JSON.stringify(matchedItem)); // 深拷贝
                        }
                        console.log(this.nodeVehicleArrivalStatusList)

                    }
                });
        },
        // 检查时间 弹出框 确定按钮
        confirmBaggageCheckTime(data) {
            this.queryData.ClassTime = this.$moment(this.queryData.ClassTime)
                .hour(data.split(':')[0])
                .minute(data.split(':')[1])
            this.isShowBaggageCheckTime = false;
        },
        openBaggageCheckTimePopup() {
            this.baggageCheckTime = this.$moment(this.queryData.ClassTime).format("HH:mm");
        },
        // 检查日期 弹出框 确定按钮
        confirmBaggageCheckDate(date) {
            this.queryData.ClassTime = this.$moment(this.queryData.ClassTime)
                .year(date.getFullYear())
                .month(date.getMonth())
                .date(date.getDate());
            this.isShowBaggageCheckDate = false;
        },

        // 获取本地数据
        getLocalData() {
            let localData = this.$utils.localData.get("adminInfo", Object);
            this.queryData.GID = null;
            this.queryData.ModifyGID = localData.GID;
            this.queryData.ModifyName = localData.UserName;
            this.queryData.ModifyCode = localData.UserCode;
            this.queryData.LineClassDayGID = this.lineClassDay.GID;
            this.queryData.NodeGID = this.node.NodeGID;
            this.queryData.Remark = "";
            let classdatetime =
                this.$moment(this.lineClassDay.ClassDate).format("YYYY-MM-DD") +
                "  " +
                this.lineClassDay.ClassTime;
            classdatetime =
                this.$moment(classdatetime).format("YYYY-MM-DD HH:mm");
            this.nodeVehicleArrivalTime = classdatetime;
            this.queryData.ClassTime = classdatetime;
        },
        // 获取当前日期时间
        getCurrentDateTime() {
            let date = this.$moment(this.$moment());
            // this.queryData.CheckDate = date.format("YYYY-MM-DD");
            // this.queryData.CreateTime = date.format("YYYY-MM-DD HH:mm:ss");
            // this.queryData.ModifyTime = date.format("YYYY-MM-DD HH:mm:ss");
            // this.queryData.CheckTime = date.format("HH:mm");
        },

        // 点击提交
        onSubmit() {
            this.queryData.ClassTime = this.$moment(this.queryData.ClassTime).format("YYYY-MM-DD HH:mm");
            var diffMinutes = this.$moment(this.queryData.ClassTime).diff(this.$moment(this.nodeVehicleArrivalTime), 'minutes');
            if (diffMinutes == 0) {
                this.queryData.ArrivalStatus = 2
            } else if (diffMinutes > 0) {
                this.queryData.ArrivalStatus = 3
            } else {
                this.queryData.ArrivalStatus = 1
            }
            this.queryData.DifferencetTime = diffMinutes
            this.$http
                .post(this.$api.saveNodeVehicleArrivalStatus, {
                    _JsonText: JSON.stringify(this.queryData),
                })
                .then((res) => {
                    if (res.success) {
                        this.$toast("修改成功");
                        setTimeout(() => {
                            this.$router.go(-1);
                        }, 800);
                    } else {
                        this.$toast("修改失败 - " + res.msg);
                    }
                });
        },
    },
};
</script>

<style lang="less" scoped>
.baggage-main {
    .baggage-check {
        height: calc(100vh - 45px - 0.6rem);
        padding: 0.3rem;
        display: flex;
        flex-direction: column;

        .baggage-check-card {
            background-color: #fff;
            padding: 0.3rem;
            flex: 1;

            .van-form {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .baggage-cell {
                    border-bottom: 1px solid #dddddd85;
                    font-size: 0.42rem;

                    /deep/ .van-cell__title {
                        display: flex;
                        justify-items: flex-start;
                        color: #000;
                    }

                    .van-cell__value {
                        color: #000;
                    }
                }

                .van-cell::after {
                    border: none;
                }
            }
        }
    }
}
</style>
